import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, Theme } from '@mui/material/styles';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { LabelSource } from 'functions/Hooks/useLabel';

import App from './App';
import { UserSource } from './functions/Hooks/useUser';

import 'index.css';
import './i18n';
declare module '@mui/styles/defaultTheme' {
  interface DefaultTheme extends Theme {}
}

declare module '@mui/styles/defaultTheme' {
  interface DefaultTheme extends Theme {}
}

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
  <StyledEngineProvider injectFirst>
    <CssBaseline />
    <BrowserRouter>
      <UserSource>
        <link href="https://api.mapbox.com/mapbox-gl-js/v1.10.1/mapbox-gl.css" rel="stylesheet" />
        <link rel="stylesheet" href="//cdn.quilljs.com/1.2.6/quill.snow.css" />
        <LabelSource>
          <App />
        </LabelSource>
      </UserSource>
    </BrowserRouter>
  </StyledEngineProvider>
);
